import React, { useState, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSeekerAnalytics } from "../../../../API/api";
import { Spin } from "antd";
import StaticTableAnt from "../../../AntDesignTable/StaticTableAnt";
import CountUp from "react-countup";
import TitleValue from "./TitleValue";
import { bindActionCreators } from "redux";
import { Actions } from "../../../../Action";
import { ReactComponent as ViewIcon } from "../../../../Icons/totalView.svg";
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import { Rate } from 'antd';
import { Progress } from "antd";
import TooltipComp from "../../../../NewComponent/ToolTip/TooltipComp";


const containerStyle = {
  width: "100%",
  margin: "auto",
  marginTop: "1%",
  marginBottom: "1%",
  border: "1px solid #E0E2E6",
  background: "#FFFFFF",
  borderRadius: "12px",
  boxShadow: "0px 4px 16px 0px #1018280F",
  padding: "28px",

};


export default function SeekerSearchStatistics({ userType }) {
  // seekerAnalyticsAction
  const [sortInfo, setSortInfo] = useState({});

  const [seekerAnalytics, setSeekerAnalytics] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const { seekerAnalyticsAction } = bindActionCreators(Actions, dispatch);
  const cmState=useSelector((state)=>state.cmRoot)
  const { geoLevelId, geoLevelValue, domainId, length, check } = useSelector(
    (state) => {
      return {
        geoLevelId: state.cmRoot.selecetdRoutingValue,
        geoLevelValue: state.cmRoot?.selectedGeoLevel?.name,
        domainId: state.cmRoot?.selectedDomainIds,
        length: state.cmRoot?.selectedDomainsObj?.length,
        check: state.cmRoot.selecetdRoutingValue,
      };
    }
  );

  const columnsData = [
    {
      title: TitleValue("Geo"),
      dataIndex: "Geo",
      // sorter: (a, b) => a.Geo.length - b.Geo.length,
      sorter: (a, b) => a?.Geo?.localeCompare(b?.Geo),
      align: "left",
      width: 160,
      render: (_, raw) => (
        <>
          <span style={{  fontSize: "13px",
          color: "#2A364A",
          fontWeight: "500", zIndex: 999 }}>
            {raw.Geo}
          </span>
        </>
      ),
    },
    {
      title: TitleValue("Seeker"),
      dataIndex: "seeker",
      sorter: (a, b) => a.seeker.localeCompare(b.seeker),
      align: "left",
      width: 250,
      render: (_, raw) => (
        <>
          <span style={{   fontSize: "13px",
          color: "#2A364A",
          fontWeight: "500",}}>
            {raw.seeker}
          </span>
        </>
      ),
    },
    {
      title: TitleValue("Searched"),
      dataIndex: "Searched",
      sorter: (a, b) => a.Searched - b.Searched,
      align: "center",
      width: 150,
      render: (_, raw) => (
        <>
          <span
            style={{
              fontSize: "13px",
              color: "#2A364A",
              fontWeight: "500",
              display: "flex",
              width: "50%",
              justifyContent: "flex-end",
              textAlign: "right",
            }}
          >
            <CountUp end={raw.Searched} />
            {/* {raw.Searched} */}
          </span>
        </>
      ),
    },
    {
      title: TitleValue("Submitted"),
      dataIndex: "Submitted",
      sorter: (a, b) => a.Submitted - b.Submitted,
      // sortOrder: sortInfo.field === "Submitted" ? sortInfo.order : null,
      align: "center",
      width: 150,
      render: (_, raw) => (
        <>
          <span
            style={{
              fontSize: "13px",
              color: "#2A364A",
              fontWeight: "500",
              display: "flex",
              width: "50%",
              justifyContent: "flex-end",
              textAlign: "right",
            }}
          >
            <CountUp end={raw.Submitted} />
          </span>
        </>
      ),
    },
    {
      title: TitleValue("Rated"),
      dataIndex: "Rated",
      sorter: (a, b) => a.Rated - b.Rated,
      // sortOrder: sortInfo.field === "Rated" ? sortInfo.order : null,

      align: "center",
      width: 150,
      style: { fontSize: "13px", fontWeight: "300" },
      render: (_, raw) => {
        const max = 20;
        const rating = raw.Rated;
        const normalized = (rating / max) * 5;
        return (
          // <TooltipComp title={`${rating} / ${max}`}>


          //   <div style={{
          //     fontSize: "13px",
          //     color: "#2A364A",
          //     fontWeight: "500", display: "flex", alignItems: "center", gap: "8px", justifyContent: "flex-end"
          //   }}>
          //     <Rate allowHalf disabled value={normalized} style={{ fontSize: 14 }} />
          //   </div>
          // </TooltipComp>
          <>
             <span
            style={{
              fontSize: "13px",
              color: "#2A364A",
              fontWeight: "500",
              display: "flex",
              width: "50%",
              justifyContent: "flex-end",
              textAlign: "right",
              gap: "5px",
              marginLeft: "10px"
            }}
          >
            <CountUp end={raw.Rated} />
            {/* <ViewIcon /> */}
            {/* {raw.TrendingViews} */}
          </span>
          
          </>
        );
      },
    },
    {
      title: TitleValue("Trending Views"),
      dataIndex: "TrendingViews",
      sorter: (a, b) => a.TrendingViews - b.TrendingViews,
      align: "center",
      // sortOrder: sortInfo.field === "TrendingViews" ? sortInfo.order : null,
      style: { fontSize: "13px", fontWeight: "300" },
      width: 150,
      render: (_, raw) => (
        <>
          <span
            style={{
              fontSize: "13px",
              color: "#2A364A",
              fontWeight: "500",
              display: "flex",
              width: "50%",
              justifyContent: "flex-end",
              textAlign: "right",
              gap: "5px",
              marginLeft: "10px"
            }}
          >
            <CountUp end={raw.TrendingViews} />
            {/* <ViewIcon /> */}
            {/* {raw.TrendingViews} */}
          </span>
        </>
      ),
      
    },
    {
      title: TitleValue("Deflection Rate"),
      dataIndex: "DeflectionRate",
      sorter: (a, b) => a.DeflectionRate - b.DeflectionRate,
      // sortOrder: sortInfo.field === "DeflectionRate" ? sortInfo.order : null,
      align: "center",
      width: 150,
      style: { fontSize: "13px", fontWeight: "200", zIndex: 0 },
      render: (_, raw) => (
        <div style={{
          fontSize: "13px",
          color: "#2A364A",
          fontWeight: "500",
          display: "flex", justifyContent: "center", alignItems: "center"
        }}>
          <Progress
            type="circle"
            percent={raw.DeflectionRate}
            width={40}
            strokeColor={
              raw.DeflectionRate > 70 ? "#0099ff" :
                raw.DeflectionRate > 40 ? "#0099ff" :
                  "#2A364A"
            }
            format={(percent) => (
              <div style={{ fontSize: "10px", padding: "2px", color: "#2A364A",textAlign:'center' }}>{percent}%</div>
            )}
          />
        </div>
      ),
    }
  ];

  const selectUser = useSelector((state) => state.seekerType);
  React.useEffect(() => {
    // console.log('render')
    if (check !== "") {
      setLoading(true);
      getSeekerAnalytics(
        geoLevelId,
        geoLevelValue,
        selectUser.userType.value !== null ? selectUser.userType.value : "",
        domainId,
        setCount
      ).then((res) => {
        if (res === undefined) return;
        setLoading(false);
        setSeekerAnalytics(res);
        seekerAnalyticsAction(res)
      });
    }
    setCurrentPage(1);
  }, [domainId, geoLevelId, geoLevelValue, length, selectUser.userType, check,cmState]);
  // const row = seekerAnalytics;

  // console.log("geoLevelValue",cmState)
  return (
    <Spin
    spinning={loading}
    style={{
      marginTop: "30px",
      width: "100%",
      // padding: "30px",

      // paddingTop: "15px",
      // paddingBottom: "15px",
    }}
  >
    <div
      style={{
        paddingTop: "15px",
        // marginTop: "15px",
      }}
    >
      <StaticTableAnt
        columns={columnsData}
        data={seekerAnalytics}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        count={count}
        Header="Seeker Search Statistics"
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        searchBoolean={true}
        sortInfo={sortInfo}
        setSortInfo={setSortInfo}
      />
    </div>
  </Spin>
  );
}
